import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api.js';

export default function LoginPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const tokenFromUrl = params.get('token');

  useEffect(() => {
    if (tokenFromUrl) {
      // Auto-login on invite link click
      setLoading(true);
      api
        .login(tokenFromUrl)
        .then(() => {
          // Persist token locally as a fallback for later sessions where
          // the cookie has been cleared (different device, incognito, etc.)
          try {
            localStorage.setItem('ccf_invite_token', tokenFromUrl);
          } catch {}
          navigate('/map');
          window.location.reload();
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }
  }, [tokenFromUrl, navigate]);

  async function handleManual(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const token = e.target.token.value.trim();
    try {
      await api.login(token);
      try {
        localStorage.setItem('ccf_invite_token', token);
      } catch {}
      navigate('/map');
      window.location.reload();
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }

  return (
    <div className="h-full flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-8">
        <h1 className="text-2xl font-bold text-ccf-primary mb-2">CCF Board Dashboard</h1>
        <p className="text-gray-600 text-sm mb-6">
          Please sign in with your invite link.
        </p>

        {loading && <div className="text-sm text-gray-600">Signing in...</div>}

        {!loading && !tokenFromUrl && (
          <form onSubmit={handleManual} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Invite Token
              </label>
              <input
                name="token"
                type="text"
                placeholder="Paste your invite token"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-ccf-primary"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-ccf-primary text-white rounded py-2 hover:bg-blue-900"
            >
              Sign In
            </button>
          </form>
        )}

        {error && (
          <div className="mt-4 text-sm text-ccf-danger bg-red-50 border border-red-200 rounded p-3">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}
